import { useNavigate } from "react-router-dom";
import HeaderRightButtons from "./HeaderRightButtons";
import Logo from "../../assets/logo.png";
import { styled } from "@mui/material";

const HeaderContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  padding: "2rem",
});

const LogoImage = styled("img")({
  width: "clamp(7px, 7%, 40px)",  
  height: "auto",
  maxHeight: "40px", 
  marginLeft: "2rem",
  cursor: "pointer",
});

const Header = () => {
  const navigate = useNavigate();

  return (
    <HeaderContainer>
      <LogoImage src={Logo} onClick={() => navigate("/")} />
      <HeaderRightButtons />
    </HeaderContainer>
  );
};

export default Header;
